/**
 * Helpers for reading the custom data Capacitor hands back on a remote push.
 *
 * Kept dependency-free (no React) so it can be unit-tested standalone and
 * reused from the PushLifecycle listener wiring.
 */

/**
 * Pull a client route out of a push's custom data. APNs / Capacitor serialise
 * custom payloads variably, so tolerate an href at the top level, a nested
 * `nexus_payload` object, or a JSON-string `nexus_payload`. Returns null when
 * there is no usable href (e.g. N-06 milestone pushes carry no href).
 */
export function extractHref(data: Record<string, any> | null | undefined): string | null {
  if (!data) return null;
  const direct = data.href ?? data.nexus_payload?.href;
  if (typeof direct === "string" && direct.length > 0) return direct;
  const raw = data.nexus_payload;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed?.href === "string" && parsed.href.length > 0) return parsed.href;
    } catch {
      /* not JSON — fall through */
    }
  }
  return null;
}
